import React, { Component } from 'react';

import moment from 'moment-with-locales-es6';
import { connect} from "remx";
import broker from '../../../utils/broker';

import dataStore from '../../../stores/data';
import ChartMonaBulan from '../../../components/Charts/ChartMonaBulan';


const month_name = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];


class ChartPelanggan extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.options = {
          sortIndicator: true,
          hideSizePerPage: true,
          paginationSize: 6,
          hidePageListOnlyOnePage: true,
          clearSearch: true,
          alwaysShowAllBtns: false,
          withFirstAndLast: false
        }
        this.state = {
          reload:false,
          loading: false,
          data : {},
          keterangan : '',
        }
      }

      getDataTraffic(){
          var year = moment(this.props.date_view).locale('id').format('Y');
          broker.fetchSupport.get(`generate_graphic?id=${this.props.pelanggan_id}&month=${parseInt(this.props.month_view)+1}&year=${year}`)
          .then(res => {
              const { data } = res;
              if (data && this._isMounted) {
                  this.setState({data : data});
              } else {
  
              }
          }).catch(err => {
              
          });
      }

      getDataTrafficDaily(){
          broker.fetchSupport.get(`generate_graphic_daily?id=${this.props.pelanggan_id}&date=${moment(this.props.date_view).locale('id').format('YYYY-MM-DD') }`)
          .then(res => {
              const { data } = res;
              if (data && this._isMounted) {
                  this.setState({data : data});
              } else {
  
              }
          }).catch(err => {
              
          });   
      }


      componentDidMount(){
        this._isMounted = true;
        if (this.props.type_view === 'day'){
            this.setState({keterangan : 'Tgl. ' + moment(this.props.date_view).locale('id').format('DD MMMM YYYY')}, function(){
              this.getDataTrafficDaily();
            });    
        } else {
            this.setState({keterangan : 'Bulan ' + month_name[this.props.month_view]}, function(){
              this.getDataTraffic();
            });
           
        }
      }

      componentWillUnmount(){
        this._isMounted = false;
      }

      componentDidUpdate(prevProps, prevState) {
          // if (this.props.type_view !== prevProps.type_view ||
          //   this.props.month_view !== prevProps.month_view ||
          //   this.props.date_view !== prevProps.date_view ||
          //   this.props.pelanggan_id !== prevProps.pelanggan_id ||
          //   this.props.show_map !== prevProps.show_map) {
             
          //     if (this.show_map) {
          //       if (this.props.type_view === 'day'){
          //           this.getDataTrafficDaily();
          //           this.setState({keterangan : 'Tgl. ' + moment(this.props.date_view).locale('id').format('DD MMMM YYYY')});
          //       } else {
          //           this.getDataTraffic();
          //           this.setState({keterangan : 'Bulan ' + month_name[this.props.month_view]});
          //       }
          //     }

          // }
      }

      
    render(){
        // console.log(this.props.pelanggan_id)
        if (this.state.data.rate){
          return(
            <div className="mg-b-50">
              <ChartMonaBulan data={this.state.data} keterangan={this.state.keterangan} />
              <table className="table table-bordered mg-b-0">
              <tbody>
                <tr>
                  <th scope="row">Upload</th>
                  <td>Current</td>
                  <td>{this.state.data.rate.upload_current} Mbps</td>
                  <td>Average</td>
                  <td>{this.state.data.rate.upload_avg} Mbps</td>
                  <td>Max</td>
                  <td>{this.state.data.rate.upload_max} Mbps</td>
                </tr>
                <tr>
                  <th scope="row">Download</th>
                  <td>Current</td>
                  <td>{this.state.data.rate.download_current} Mbps</td>
                  <td>Average</td>
                  <td>{this.state.data.rate.download_avg} Mbps</td>
                  <td>Max</td>
                  <td>{this.state.data.rate.download_max} Mbps</td>
                </tr>
              </tbody>
            </table>
            </div> 
          );
        } else {
          return null;
        }
        
    }

}

function mapStateToProps(props) {
    return {
      type_view : dataStore.getters.getDataTypeView(),
      year_view : dataStore.getters.getDataYearView(),
      month_view : dataStore.getters.getDataMonthView(),
      date_view : dataStore.getters.getDataDateView(),
      form_view : dataStore.getters.getDataFormView(),
    }
}


export default connect(mapStateToProps)(ChartPelanggan);